import { useMutation } from "@tanstack/react-query";
import { useUpdateUserPhaseActionStatus } from "@platform/hooks/useUpdateUserPhaseActionStatus";
import { apiRequest } from "@shared/services/api/apiRequest";
import { TimeslotId } from "../../timeslots/timeslots.types";

export function useSubmitSchedulingAvailability(
  programId: number,
  userPhaseActionId: number,
  onSuccess?: () => void
) {
  const updateUserPhaseActionStatus = useUpdateUserPhaseActionStatus({
    userPhaseActionId,
    status: "completed",
  });

  return useMutation({
    mutationFn: async (data: TimeslotId[]) => {
      const payload = {
        program_id: programId,
        time_slots: data,
      };

      return await apiRequest(`/api/save-availability-slots/`, "POST", payload);
    },
    onSuccess: () => {
      updateUserPhaseActionStatus.mutate();

      onSuccess?.();
    },
  });
}

export default useSubmitSchedulingAvailability;
